<template>
  <div class="message common-flex">
    <div class="message-list">
      <!-- 标题 -->
      <div
        class="
          message-header
          common-flex common-justify-between common-align-center
        "
      >
        <div class="message-title">{{ $t("message.title") }}</div>
        <div
          @click="readAll"
          class="common-flex common-align-center common-hover"
          style="color: #0a4dcc; font-size: 14px"
        >
          <div class="iconfont iconyidu"></div>
          <div>{{ $t("message.readAll") }}</div>
        </div>
      </div>
      <!-- 状态选择 -->
      <div class="message-status">
        <!-- statusMenu -->
        <div class="message-menu common-flex">
          <div
            class="common-hover"
            @click="changeUrgencyType(item)"
            :class="params.urgencyType === item.id ? 'message-menu-check' : ''"
            v-for="(item, index) in statusMenu"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 信息列表 -->
      <div
        class="common-rowUnder"
        :style="{ height: 'calc(100vh - 190px)', overflowY: 'auto' }"
        @scroll="scrollEvent"
        style="position: relative;"
      >
        <Spin size="large" fix v-if="spinShow"></Spin>

        <div
          @click="chooseMessage(item.id, item)"
          :style="[messageId == item.id ? { background: '#fff' } : {}]"
          :class="messageId == item.id ? '' : 'message-item-line'"
          class="message-item common-flex common-hover"
          v-for="(item, index) in messageList"
          :key="index"
        >
          <div class="message-icons iconfont iconicon2">
            <div class="message-isread" v-if="item.isRead == 0"></div>
          </div>
          <div
            class="
              common-flex
              common-justify-between
              common-direction-column
              common-justify-between
            "
            style="width: 340px"
          >
            <div class="common-flex common-justify-between common-align-center">
              <div class="title">{{ item.title }}</div>
              <div class="time">{{ item.time }}</div>
            </div>
            <div class="content">{{ item.content }}</div>
          </div>
        </div>
          <rNull
          v-if="messageList.length == 0"
            imgStyle="width:300px;margin:0 auto"
            titleStyle="font-size:16px;color:#999"
            :title="$t('noResult')"
          ></rNull>
      </div>
    </div>
    <div class="message-details" v-if="messageChoose">
      <div class="details-header common-flex common-justify-between">
        <div class="common-flex">
          <div class="iconfont iconicon2"></div>
          <div
            class="common-flex common-direction-column common-justify-between"
          >
            <div class="title">{{ messageChoose.sendUsername }}</div>
            <div class="time">{{ messageChoose.createTime }}</div>
          </div>
        </div>
        <div
          @click="delAddress"
          class="iconfont iconshanchudizhi common-hover"
        ></div>
      </div>
      <div
        class="message-content common-rowUnder"
        :style="{ height: 'calc(100vh - 140px)', overflowY: 'auto' }"
      >
        {{ messageChoose.content }}
      </div>
      <!-- <div class="send-email">
        <div class="common-flex common-justify-between">
          <div class="common-flex">
            <Icon type="md-attach" />
            <div class="add-attachment">{{ $t("message.addAttachment") }}</div>
          </div>
          <div class="common-flex">
            <div
              class="attachment-item common-flex common-align-center"
              v-for="(item, index) in attachment"
              :key="index"
            >
              <div>
                {{ item.name }}
              </div>
              <div class="iconfont iconguanbi common-hover"></div>
            </div>
          </div>
        </div>
        <Input
          suffix="md-send"
          :placeholder="$t('message.pleaseEnter')"
          style="width: 920px; margin-top: 10px"
        />
      </div> -->
    </div>
    <div class="message-details" style="background: #fff" v-else></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import rNull from "../../components/r-null.vue";
export default {
  name: "message",
  data() {
    return {
      spinShow:false,
      pages: 0,
      // 附件列表
      attachment: [{ name: "xxx.png" }],
      statusMenu: [
        {
          name: this.$t("message.menu.all"),
          id: "",
        },
        {
          name: this.$t("message.menu.normal"),
          id: 0,
        },
        {
          name: this.$t("message.menu.urgent"),
          id: 1,
        },
      ],

      params: {
        pageSize: 10,
        pageNum: 1,
        urgencyType: "",
      },

      messageChoose: "",
      // 选择的消息
      messageId: "",
      messageList: [],
    };
  },
  components: {
    rNull,
  },
  mounted() {
    this.news();
  },
  methods: {
    ...mapActions([
      "newsAction", //消息列表
      "updateMessageReadAction", //已读消息
      "updateMessageDeleteAction", //消息删除
      "updateMessageReadAllAction", //消息全部已读
    ]),
    // 消息全部已读
    readAll() {
      this.$Modal.confirm({
        title: this.$t("delMsg.tips"),
        content: this.$t("message.readAllTips"),
        okText: this.$t("user.determine"),
        cancelText: this.$t("user.cancel"),
        onOk: () => {
          this.updateMessageReadAllAction().then((res) => {
            if (res.code == 0) {
              this.messageChoose = "";
              this.params.pageNum = 1;
              this.news();
            }
          });
        },
      });
    },
    // 删除地址
    delAddress() {
      this.$Modal.confirm({
        title: this.$t("delMsg.tips"),
        content: this.$t("delMsg.content"),
        okText: this.$t("user.determine"),
        cancelText: this.$t("user.cancel"),
        onOk: () => {
          this.updateMessageDeleteAction({ id: this.messageChoose.id }).then(
            (res) => {
              if (res.code == 0) {
                this.messageChoose = "";
                this.params.pageNum = 1;
                this.news();
              }
            }
          );
        },
      });
      this.updateMessageDeleteAction;
    },
    // 下拉
    scrollEvent(e) {
      if (
        e.srcElement.scrollTop + e.srcElement.offsetHeight >
        e.srcElement.scrollHeight - 10
      ) {
        if (this.pages > this.params.pageNum) {
          this.params.pageNum++;
          this.news();
        }
        //加载更多
      }
    },
    // 修改当前选项
    changeUrgencyType(e) {
      this.params.urgencyType = e.id;
      this.params.pageNum = 1;
      this.news();
    },
    // 选择信息
    chooseMessage(e, msg) {
      
      this.messageId = e;
      this.messageChoose = msg;
      this.updateMessageReadAction({
        id: e,
      }).then((res) => {
        if (res.code == 0) {
          msg.isRead = 1;
        }
      });
    },
    news() {
      this.spinShow = true
      this.newsAction(this.params).then((res) => {
        this.pages = res.pages;
        if (this.params.pageNum == 1) {
          this.messageList = res.data;
        } else {
          this.messageList = this.messageList.concat(res.data);
        }
      }).finally(res=>{
        this.spinShow = false
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-input {
  height: 46px;
  border: none;
  background: #f8f8f8;
}
/deep/.ivu-input-suffix {
  line-height: 46px;
}
.message {
  width: 1440px;
  margin: 0 auto;
  // min-height: 100vh;
  .message-list {
    width: 470px;
    background-color: #f8f8f8;
    .message-header {
      padding: 0 25px 0 40px;
      height: 80px;
      .iconyidu {
        margin-right: 8px;
        font-size: 14px;
      }
      .message-title {
        font-size: 16px;
        font-family: Roboto;
        font-weight: 700;
        text-align: left;
        color: #000000;
        line-height: 19px;
      }
    }
    .message-item {
      height: 90px;
      padding: 25px 20px 25px 40px;
      position: relative;
      // .message-item-line{
      // }

      .message-icons {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        position: relative;
        margin-right: 12px;
        font-size: 16px;
        color: #fff;
        text-align: center;
        line-height: 40px;
        background: #ffa601;
        .message-isread {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #c9000f;
          position: absolute;
          bottom: 4px;
          right: 0;
          border: 1px solid #fff;
        }
      }
      .title {
        font-size: 14px;
        font-family: Roboto, Roboto-Medium;
        font-weight: 500;
        text-align: left;
        color: #000000;
        line-height: 16px;
      }
      .time {
        opacity: 0.4;
        font-size: 12px;
        font-family: Roboto, Roboto-Regular;
        font-weight: 400;
        text-align: right;
        color: #081938;
        line-height: 14px;
      }
      .content {
        opacity: 0.4;
        font-size: 12px;
        font-family: Roboto, Roboto-Regular;
        font-weight: 400;
        text-align: left;
        color: #081938;
        line-height: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .message-item-line::after {
      content: "";
      height: 1px;
      width: 440px;
      background: #e5e6e8;
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
  .message-status {
    width: 260px;
    height: 50px;
    padding-left: 40px;
    background: #f8f8f8;
    .message-menu {
      width: 260px;
      height: 30px;
      border: 1px solid #dfe1e4;
      border-radius: 4px;
      overflow: hidden;
      > div {
        width: 86px;
        line-height: 30px;
        font-size: 12px;
        font-family: Roboto;
        text-align: center;
        color: #000;
      }
      .message-menu-check {
        background: #081938;
        color: #fff;
      }
    }
  }
  .message-details {
    width: 970px;
    background: #fff;
    .details-header {
      padding: 20px 25px;
      height: 80px;
      border-bottom: 1px solid #ecedef;
    }
    .iconicon2 {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #ffa601;
      font-size: 16px;
      line-height: 40px;
      text-align: center;
      margin-right: 11px;
      color: #fff;
    }
    .iconshanchudizhi {
      font-size: 16px;
      color: #c9000f;
    }
    .title {
      font-size: 14px;
      font-family: Roboto;
      font-weight: 600;
      text-align: left;
      color: #000000;
      line-height: 16px;
    }
    .time {
      opacity: 0.4;
      font-size: 12px;
      font-family: Roboto, Roboto-Regular;
      font-weight: 400;
      text-align: right;
      color: #081938;
      line-height: 14px;
    }
    .message-content {
      padding: 20px 25px;
      opacity: 0.7;
      font-size: 14px;
      font-family: Roboto, Roboto-Regular;
      font-weight: 400;
      text-align: left;
      color: #000000;
      line-height: 31px;
    }
    .send-email {
      height: 100px;
      padding: 14px 25px 15px 25px;
      border-top: 1px solid #ecedef;
      .add-attachment {
        font-size: 12px;
        font-family: ArialMT;
        text-align: left;
        color: #333333;
        line-height: 14px;
        margin-left: 4px;
      }
      .attachment-item {
        height: 20px;
        padding: 0 8px;
        line-height: 20px;
        border: 1px solid #e6e8eb;
        border-radius: 2px;
        font-size: 12px;
        .iconguanbi {
          margin-left: 6px;
          font-size: 10px;
          transform: scale(0.8);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/message/message.vue